<style>
.box {
  width: 550px;
  background-color: white;
}
</style>
<template lang="pug">
v-container(fluid="")
  v-layout(row="", wrap="")
    v-flex.text-xs-center(xs12="", mt-15="")
      h1(style="text-align: center; margin-bottom: 50px; font-size: 45px") Register Account
    v-flex(xs12="", sm6="", offset-sm4="", mt-3="")
      .box
        form
          v-layout(column="")
            v-flex
              v-text-field(
                v-model="nama",
                label="Name",
                type="email",
                outlined,
                browser-autocomplete="nama",
                required
              )
            v-flex
              v-text-field(
                v-model="email",
                label="Email",
                type="text",
                outlined,
                browser-autocomplete="email",
                required
              )
            v-flex
              v-text-field(
                v-model="jabatan",
                label="Position",
                type="text",
                outlined,
                required
              )
            v-flex.text-xs-center(mt-5="")
              v-btn(
                color="red",
                type="submit",
                block,
                style="color: white; padding: 25px"
              ) Sign Up
              p(
                style="text-decoration: none; color: black; margin-left: 180px; margin-top: 40px"
              ) Already Have Account ? <br/> <br/>
                a(
                  href="#/login",
                  style="margin-left: 70px; color: red; margin-top: 15px"
                ) Sign In
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "SignUpForm",
};
</script>
